import { IItemRateDto } from "@app/shared/models/dtos/item-rate";
import { Validator } from 'fluentvalidation-ts';
import { IRateValue } from '../dtos/rate-value';

export class ItemRateDtoValidator extends Validator<IItemRateDto> {
  constructor() {
    super();

    this.ruleFor('EffectiveDate').notNull().withMessage('Effective Date is required.');
    this.ruleFor('Rate').greaterThanOrEqualTo(0).withMessage('Negative rate values are not allowed.');
  }
}

export class RateValueNoLookupValidator extends Validator<IRateValue> {
  constructor() {
    super();

    const allowedPrefixes = ["=", "<>", "<", "<=", ">", ">=", "%%", "LIKE", "BETWEEN"];

    //BETWEEN is being used. Validate it.
    this.ruleFor('FieldValue')
      .must((fieldValue) => {
        const betweenComponents = fieldValue.slice(8).split(' AND ');
        return betweenComponents.length === 2 && betweenComponents[0].trim() !== '' && betweenComponents[1].trim() !== '';
      })
      .withMessage("The BETWEEN operator needs to be in this format: 'BETWEEN X AND Y'")
      .when((model) => model.FieldValue && model.FieldValue.startsWith("BETWEEN"));

    //LIKE is being used. Validate it.
    this.ruleFor('FieldValue')
      .must((fieldValue) => {
        const likeComponent = fieldValue.slice(5).trim();
        return likeComponent.includes('%') || likeComponent.includes('_');
      })
      .withMessage("The LIKE operator needs at least one '%' or '_' in the string.")
      .when((model) => model.FieldValue && model.FieldValue.startsWith("LIKE"));

    //if something else is input other than BETWEEN or LIKE
    this.ruleFor('FieldValue')
      .must((fieldValue) => {
        //if not using a prefix, let it pass
        if (!allowedPrefixes.some((prefix) => fieldValue.includes(prefix))) {
          return true;
        }

        //a prefix is being used. Validate that it is first and has a space after it.
        return allowedPrefixes.some((prefix) => fieldValue.startsWith(prefix + " "));
      })
      .withMessage('Rate Attributes should be either a number or a string. If using an operator, it must be one of the following, followed by a space: =, <>, <, <=, >, >=, %%, LIKE, BETWEEN')
      .when((model) => model.FieldValue && (!model.FieldValue.startsWith("BETWEEN") && !model.FieldValue.startsWith("LIKE")));
  }
}